import { useCallback } from 'react'

import { Ok } from 'ts-results'

import { useApi } from 'app/common/application'

import { GoogleAnalyticsPropertiesGetRequest, GoogleAnalyticsPropertiesGetResponse } from '../types'

const useGoogleAnalyticseConnectionApi = () => {
  const { create } = useApi()

  const getProperties = useCallback(
    async (externalAccountId: string) => {
      const result = await create<
        GoogleAnalyticsPropertiesGetRequest,
        GoogleAnalyticsPropertiesGetResponse
      >(`/connections/googleAnalytics/getProperties`, { content: { externalAccountId } })
      if (result.ok) {
        return Ok(result.val.data)
      }

      return result
    },
    [create],
  )

  return {
    getProperties,
  }
}

export default useGoogleAnalyticseConnectionApi
